import { render, staticRenderFns } from "./GroupMoreMenu.vue?vue&type=template&id=800f9686&scoped=true"
import script from "./GroupMoreMenu.vue?vue&type=script&lang=js"
export * from "./GroupMoreMenu.vue?vue&type=script&lang=js"
import style0 from "./GroupMoreMenu.vue?vue&type=style&index=0&id=800f9686&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800f9686",
  null
  
)

export default component.exports